import React, {useEffect, useState} from "react";
import useDebounce from "../../hooks/useDebounce";
import {useNavigate} from "react-router-dom";
import {FiSearch} from "react-icons/fi";
import Loader from "../../components/common/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import CommentLoader from "../../components/common/CommentLoader";
import notFound from "../../assets/not-found/not_found.png";
import {TruncatedHtmlTextContent} from "../../components/TruncatedHtmlTextContent/TruncatedHtmlTextContent";
import {playlistService} from "../../services/playlistsService/playlistService";
import PlaylistsList from "./components/PlaylistsList";
import "./playlists.css";
import FavoriteMasterclasses from "../dashboard/components/FavoriteMasterclasses";
import {MasterClassService} from "../../services/masterClassService/masterClassService";
import AddPlaylistModal from "./modals/AddPlaylistModal";

const Playlists = () => {
    const [playlists, setPlaylists] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 750);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const navigate = useNavigate();
    const [favorites, setFavorites] = useState([]);
    const [isFavoritesLoading, setIsFavoritesLoading] = useState(true);
    const [showCreateModal, setShowCreateModal] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsLoading(true);
        setPage(1);
        getAllPlaylists(1, true);
    }, [debouncedSearchTerm]);

    useEffect(() => {
        getFavorites();
    }, []);

    const getAllPlaylists = async (currentPage = page, isNewSearch = false) => {
        try {
            const response = await playlistService.getPlaylists(currentPage, searchTerm);
            const newPlaylists = response.data.data;

            if (isNewSearch) {
                setPlaylists(newPlaylists);
            } else {
                setPlaylists(prevPlaylists => [...prevPlaylists, ...newPlaylists]);
            }

            if (newPlaylists.length === 0) {
                setHasMore(false);
            } else {
                setPage(currentPage + 1);
            }

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const getFavorites = async () => {
        setIsLoading(true);
        try {
            const response = await MasterClassService.getFavorites();

            setFavorites(response.data.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsFavoritesLoading(false);
        }
    };

    const handleCreatePlaylist = (playlist) => {
        playlists.unshift(playlist);
    };

    return (
        <>
            <div className="container-fluid">
                {isFavoritesLoading
                    ? (<CommentLoader />)
                    :
                    <>
                        {favorites?.length !== 0 &&
                            <div className="py-3">
                                <FavoriteMasterclasses
                                    masterClasses={favorites}
                                />
                            </div>
                        }
                    </>
                }
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h3 className="d-lg-block">Playlists</h3>
                    <div className="search-container">
                        <input onChange={handleSearch} value={searchTerm} placeholder="Search"
                               className="search-input" autoFocus={true}/>
                        <FiSearch className="search-icon"/>
                    </div>
                </div>
                <button className="btn btn-primary mb-2" style={{width: "max-content"}}
                        onClick={() => setShowCreateModal(true)}>
                    New Playlist
                </button>
                {isLoading ? (
                    <Loader />
                ) : (
                    <div className="masterclasses-scroll-container">
                        {playlists.length > 0 && (
                            <InfiniteScroll
                                next={() => getAllPlaylists(page)}
                                hasMore={hasMore}
                                loader={isLoading ? <CommentLoader/> : <></>}
                                dataLength={playlists.length}
                            >
                                <div className="masterclasses-scroll-content" style={{overflow: "hidden"}}>
                                    <PlaylistsList playlists={playlists} />
                                </div>
                            </InfiniteScroll>
                        )}
                        {playlists?.length === 0 && (
                            <div className="w-100 mt-3 rounded-4 text-center d-flex flex-column align-items-center justify-content-center" style={{ height: "300px" }}>
                                <img crossOrigin="anonymous" src={notFound} alt="data not found" width={200} />
                                <h3>No playlist found</h3>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {showCreateModal &&
                <AddPlaylistModal
                    onClose={() => setShowCreateModal(false)}
                    onCreated={handleCreatePlaylist}
                />
            }
        </>
    );
};

export default Playlists;